var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

import { observable, action } from 'mobx';

import _ from 'lodash';

import { subscribe } from 'sdc-publish-subscribe';

import api from '../ContentListApi';

import { TypedStore } from '../TypedStore';

export var HelpStore = (_class = function (_TypedStore) {
  _inherits(HelpStore, _TypedStore);

  function HelpStore(options) {
    _classCallCheck(this, HelpStore);

    var _this = _possibleConstructorReturn(this, _TypedStore.call(this, _extends({}, options, {
      listName: 'values'
    })));

    _initDefineProp(_this, 'help', _descriptor, _this);

    _initDefineProp(_this, 'language', _descriptor2, _this);

    _initDefineProp(_this, 'setLanguage', _descriptor3, _this);

    _this.parseData = function (deferred) {
      return action(function (payload) {
        _this.help = _.keyBy(payload.values, 'key');
        _this.setEntries(deferred)(payload);
      });
    };

    _this.hasHelpFor = function (key) {
      return _this.help[key] !== undefined;
    };

    _this.helpFieldFor = function (key, field) {
      if (!_this.hasHelpFor(key)) return '';

      var help = _this.help[key][field];
      if (typeof help === 'string') return help;
      return (help || {})[_this.language] || (help || {}).en || '';
    };

    _this.helpTitleFor = function (key) {
      return _this.helpFieldFor(key, 'name');
    };

    _this.helpSubtitleFor = function (key) {
      return _this.helpFieldFor(key, 'purpose');
    };

    _this.helpTextFor = function (key) {
      return (_this.helpSubtitleFor(key) ? '**' + _this.helpSubtitleFor(key) + '**\n\n' + _this.helpFieldFor(key, 'summary') : _this.helpFieldFor(key, 'summary')) || '';
    };

    subscribe('selected-language', _this.setLanguage);
    return _this;
  }

  return HelpStore;
}(TypedStore), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'help', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'language', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return 'en';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'setLanguage', [action], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function (language) {
      _this2.language = language;
    };
  }
})), _class);

export default (function (_ref) {
  var backend = _ref.backend,
      accessKey = _ref.accessKey,
      options = _objectWithoutProperties(_ref, ['backend', 'accessKey']);

  return new HelpStore(_extends({}, options, { api: api({ backend: backend, accessKey: accessKey }) }));
});